import _classCallCheck from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { isString } from 'vega-util';
import { LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2 } from '../../channel';
import { getFieldOrDatumDef, isDatumDef, isFieldDef, isValueDef } from '../../channeldef';
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var GeoPointNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(GeoPointNode, _DataFlowNode);

  var _super = _createSuper(GeoPointNode);

  function GeoPointNode(parent, projection, fields, as) {
    var _this;

    _classCallCheck(this, GeoPointNode);

    _this = _super.call(this, parent);
    _this.projection = projection;
    _this.fields = fields;
    _this.as = as;
    return _this;
  }

  _createClass(GeoPointNode, [{
    key: "clone",
    value: function clone() {
      return new GeoPointNode(null, this.projection, duplicate(this.fields), duplicate(this.as));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(this.fields.filter(isString));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Geopoint ".concat(this.projection, " ").concat(_hash(this.fields), " ").concat(_hash(this.as));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return {
        type: 'geopoint',
        projection: this.projection,
        fields: this.fields,
        as: this.as
      };
    }
  }], [{
    key: "parseAll",
    value: function parseAll(parent, model) {
      if (!model.projectionName()) {
        return parent;
      }

      for (var _i = 0, _arr = [[LONGITUDE, LATITUDE], [LONGITUDE2, LATITUDE2]]; _i < _arr.length; _i++) {
        var coordinates = _arr[_i];
        var pair = coordinates.map(function (channel) {
          var def = getFieldOrDatumDef(model.encoding[channel]);
          return isFieldDef(def) ? def.field : isDatumDef(def) ? {
            expr: "".concat(def.datum)
          } : isValueDef(def) ? {
            expr: "".concat(def['value'])
          } : undefined;
        });
        var suffix = coordinates[0] === LONGITUDE2 ? '2' : '';

        if (pair[0] || pair[1]) {
          parent = new GeoPointNode(parent, model.projectionName(), pair, [model.getName('x' + suffix), model.getName('y' + suffix)]);
        }
      }

      return parent;
    }
  }]);

  return GeoPointNode;
}(DataFlowNode);